export default __webpack_public_path__ + "static/media/logo-nixe-linha.bb1fa238.png";